module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-kyoto-2-914f6b9383fdded64a96f73fbfc096ae.png";